"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminRoleToJSON = exports.AdminRoleFromJSONTyped = exports.AdminRoleFromJSON = exports.AdminRole = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var AdminRole;
(function (AdminRole) {
    AdminRole["GOD"] = "GOD";
    AdminRole["STANDARD"] = "STANDARD";
})(AdminRole = exports.AdminRole || (exports.AdminRole = {}));
function AdminRoleFromJSON(json) {
    return AdminRoleFromJSONTyped(json, false);
}
exports.AdminRoleFromJSON = AdminRoleFromJSON;
function AdminRoleFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AdminRoleFromJSONTyped = AdminRoleFromJSONTyped;
function AdminRoleToJSON(value) {
    return value;
}
exports.AdminRoleToJSON = AdminRoleToJSON;
